import { Routes } from "@angular/router";

export const profileRoutes: Routes = [
  {
    path: "",
    loadComponent: () => import("./profile-wrapper.component").then((c) => c.ProfileWrapperComponent),
    children: [
      {
        path: "",
        title: "MY_PROFILE.TITLE",
        loadComponent: () => import("./pages/profile/profile.component").then((c) => c.ProfileComponent),
      },
      {
        path: "events/view/:id",
        title: "EVENTS.VIEW_EVENT_DETAILS",
        loadComponent: () =>
          import("./../admin/pages/exhibitions-and-events/pages/view-event/view-event.component").then((c) => c.ViewEventComponent),
      },
    ],
  },
];
